import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { DSComponents, DesignSystemHelperService } from '@frontend/promo-utils';
import { DsCard } from '@frontend/ui/card';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResultsContent } from '../../models/results/results-content';
import { ResultsHeader } from '../../models/results/results-header';
import { TargetPromoState, resultsContent } from '../../store/target-promotion.selectors';

@Component({
    selector: 'tp-calculate-result',
    templateUrl: './calculate-result.component.html',
    styleUrls: ['./calculate-result.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetDirective, DsCard],
})
export class CalculateResultComponent {
    dsComponents: DSComponents;
    vm$: Observable<ResultsHeader> = this.store.select(resultsContent).pipe(map((resultsContent: ResultsContent) => resultsContent?.resultsHeaders));

    constructor(
        private store: Store<{ targetPromotionModuleData: TargetPromoState }>,
        private designSystemHelperService: DesignSystemHelperService,
    ) {
        this.dsComponents = this.designSystemHelperService.getDsComponentsList();
    }
}
